export default ({ store, next }) => {
  store.state.menuOpen = false;
  next();
};

